import api from '../../api/mas-athena';

const state = {
    events: [],
    newevent: []
};

const getters = {
    allEvents: state => state.events,
    confirmNewEvent: state => state.newevent,
};

const actions = {
    async fetchEvents({ commit }) {
        const response = await api.fetchEvents();

        commit('setEvents', response.data.results);
    },
    async confirmEvent({ commit }, data) {
        const response = await api.confirmEvent(data['event_id'], data['currency']);

        commit('setEvent', response);
    }    
};

const mutations = {
    setEvents: (state, events) => {
        state.events = events;
    },
    setEvent: (state, event) => {
        state.newevent = event;
    }    
};

export default {
    state,
    getters,
    actions,
    mutations
}